import React, { Component } from 'react'
import classnames from "classnames";
import Button from '../shared/Button/index';

import test from '../../img/icons/test-icon.svg';
import baseStyles from 'custom/base.styl';

export default class LanguageTestIntro extends Component {
  constructor(props) {
    super(props)

    this._handleSubmit = this._handleSubmit.bind(this)
  }

  _handleSubmit(e) {
    e.preventDefault();
    this.props.history.replace('/language-test')
  }

  render() {
    return (
      <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.testing)}>
        <form onSubmit={this._handleSubmit} method="post">
          <img className={baseStyles.content_board__icon} src={test} alt="" width="72px" />
          <div className={baseStyles.header}><h1 className={baseStyles.title}>Language test</h1></div>
          <p className={classnames(baseStyles.succeess_title)}>After passing this test you will be able to proceed with application</p>

          <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__succes)}>
            <li>During next <b>25 minutes</b> you will have to answer:</li>
            <li><b>45 multiple-choice</b> questions;</li>
            <li><b>Only one</b> answer is correct;</li>
            <li>You will <b>not be able to either pause or restart</b> the test;</li>
            <li>You will need to answer <b>all questions</b> before time runs out;</li>
          </ul>

          <p className={classnames(baseStyles.content_board__text, baseStyles.light_text)}>Are you ready to test your language?</p>
          <Button type="submit">Start a test</Button>
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LanguageTest/PageLanguageTestIntro.js